export enum SitesTableSortPropertyStoreModelEnum {
  Tenant = 'tenant',
  SiteName = 'siteName',
  Region = 'region',
  Entities = 'entities',
  Performance = 'performance',
  Status = 'status',
  EntitiesPerState = 'entitiesPerState',
  Health = 'health',
}
